import { Box, Grid, Paper, Switch, Typography } from "@mui/material";
import { VMaskTextField } from "../../../../shared/forms/VMaskTextField";

interface ITenantSolidarityParamsProps {
    isLoading: boolean;
    tenantSolidarity: boolean;
    setTenantSolidarity: (value: boolean) => void;
}

export const TenantSolidarityParams: React.FC<ITenantSolidarityParamsProps> = ({
    isLoading,
    tenantSolidarity,
    setTenantSolidarity,
}) => {
    return (
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0}>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                margin={2}
                borderRadius={2}
                border={"1px solid #e2e2e6"}
            >
                <Grid container direction="column" padding={2} spacing={2}>
                    <Grid container item direction="row" spacing={2}>
                        <Grid item md={11}>
                            <Typography variant="body1" color={"primary"} fontWeight={600}>
                                Locatário Solidário
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container item direction="row" spacing={2} marginBottom={2}>
                    <Box display={"flex"} flexDirection={"row"} alignItems={"center"} marginLeft={2} paddingX={4}>
                        <Typography>Ativar locatário solidário</Typography>
                        <Switch
                            color="secondary"
                            onChange={(e: any) => {
                                setTenantSolidarity(e.target.checked);
                            }}
                            disabled={isLoading}
                            name="tenantSolidarity"
                            checked={tenantSolidarity}
                        />
                    </Box>

                    <Grid item xs={12} sm={12} md={2}>
                        <VMaskTextField
                            fullWidth
                            label="Quantidade"
                            name="tenantSolidarityNum"
                            disabled={isLoading || !tenantSolidarity}
                            mask="inteiro"
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};
